import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import lodash from "lodash";
import ReactTooltip from "react-tooltip";
import ActiveSelect from "../general/ActiveSelect.js";
import Loading from "../general/Loading.js";
import Search from "../general/Search.js";
import LocationSelect from "../general/LocationSelect.js";
import PositionSelect from "../general/PositionSelect.js";
import EmailTd from "../table-componets/EmailTd.js";
import LinkTd from "../table-componets/LinkTd.js";
import PhoneNumberTd from "../table-componets/PhoneNumberTd.js";
import UserRoleSelect from "../general/UserRoleSelect.js";

class Users extends React.Component {
  state = {
    selectedLocationId: "",
    selectedPositionId: "",
    searchText: "",
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: "last_name",
    orderDir: "ASC",
    active: true,
    userRole: "all",
    archived: null,
    users: [],
    loading: true,
  };

  componentDidMount() {
    this.buildData();
  }

  buildData = () => {
    const params = {
      active: this.state.active,
      archived: this.state.archived,
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir,
      user_role: this.state.userRole,
      select:
        "id,first_name,last_name,email,account_id,phone_number,current_sign_in_at,active,hide_phone_number,hide_email,availability_locked",
      method:
        "devise_trackable,user_locations_html,user_positions_html,avatar_url,formatted_phone_number",
    };

    if (this.state.selectedLocationId) {
      params.location_id = this.state.selectedLocationId;
    }

    if (this.state.selectedPositionId) {
      params.position_id = this.state.selectedPositionId;
    }

    if (this.state.searchText) {
      params.search = this.state.searchText;
    }

    if (this.state.userRole) {
      params.user_role = this.state.selectedUserRole;
    }

    axios({
      method: "get",
      url: "/api/v1/employees.json",
      params: params,
      responseType: "json",
    }).then((response) => {
      this.setState({
        loading: false,
        users: response.data,
        totalPages: Math.ceil(response.headers.total / this.state.perPage),
      });
    });
  };

  newLocation(newLocation) {
    this.setState({ loading: true });
    this.setState({ selectedLocationId: newLocation });
    this.setState({ page: 1 });
    this.buildData();
  }

  newPosition(newPosition) {
    this.setState({ loading: true });
    this.setState({ selectedPositionId: newPosition });
    this.setState({ page: 1 });
    this.buildData();
  }

  newActive(newActive) {
    this.setState({ loading: true });

    let archived = null;
    let active = null;

    if (newActive === "true") {
      active = true;
    } else if (newActive === "false") {
      active = false;
    } else if (newActive === "1") {
      archived = true;
    }

    this.setState({ archived, active, page: 1 }, () => {
      this.buildData();
    });
  }

  newUserRole(newUserRole) {
    this.setState({ loading: true });
    this.setState({ selectedUserRole: newUserRole });
    this.setState({ page: 1 });
    this.buildData();
  }

  newSearch(newSearch) {
    this.setState({ loading: true });
    this.setState({ searchText: newSearch });
    this.setState({ page: 1 });
    this.buildData();
  }

  sortData(orderBy) {
    this.setState({ loading: true });

    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == "DESC") {
        this.setState({ orderDir: "ASC" });
      } else {
        this.setState({ orderDir: "DESC" });
      }
    } else {
      this.setState({ orderBy: orderBy });
      this.setState({ orderDir: "DESC" });
    }

    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  changePage(increment) {
    this.setState({ loading: true });
    var page = this.state.page + increment;
    this.setState({ page: page });
    setTimeout(
      function () {
        this.buildData();
      }.bind(this),
      50
    );
  }

  toggleLockAUserSuccess = ({ userId, availabilityLocked }) => {
    const idx = lodash.findIndex(this.state.users, { id: userId });
    if (idx < 0) {
      return;
    }

    const tmp = this.state.users;
    tmp[idx].availability_locked = availabilityLocked;

    this.setState({ users: tmp });
  };

  toggleLockByLocationSuccess = ({ usersIds, locked }) => {
    const tmp = this.state.users;

    usersIds.forEach((userId) => {
      const idx = lodash.findIndex(tmp, { id: userId });
      if (idx >= 0) {
        tmp[idx].availability_locked = locked;
      }
    });

    this.setState({ users: tmp });
  };

  renderPagination() {
    return (
      <div>
        <p>
          {"Showing page " + this.state.page + " of " + this.state.totalPages}
        </p>
        {this.state.page == 1 && (
          <a  href="#" className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page != 1 && (
          <a  href="#" className="btn btn-default" onClick={() => this.changePage(-1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_left
            </i>
          </a>
        )}
        {this.state.page < this.state.totalPages && (
          <a  href="#" className="btn btn-default" onClick={() => this.changePage(1)}>
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
        {this.state.page == this.state.totalPages && (
          <a  href="#" className="btn btn-default disabled">
            <i className="material-icons progress-bar-icon">
              keyboard_arrow_right
            </i>
          </a>
        )}
      </div>
    );
  }

  renderLocations = (userLocationHtml) => {
    if (this.props.locations.length == userLocationHtml.count) {
      return (
        <span>
          <span data-tip={userLocationHtml.tool_tip}>All Locations</span>
          <ReactTooltip />
          <br />
        </span>
      );
    } else {
      return (
        <span className="word-break">
          <div dangerouslySetInnerHTML={{ __html: userLocationHtml.html }} />
        </span>
      );
    }
  };

  renderPositions = (userPositionsHtml) => {
    if (this.props.positions.length == userPositionsHtml.count) {
      return (
        <span>
          <span data-tip={userPositionsHtml.tool_tip}>All Positions</span>
          <ReactTooltip />
          <br />
        </span>
      );
    } else if (userPositionsHtml.count == 0) {
      return <span>No Positions</span>;
    } else {
      return (
        <span className="word-break">
          <div dangerouslySetInnerHTML={{ __html: userPositionsHtml.html }} />
        </span>
      );
    }
  };

  renderLastSeenIcon(deviseTrackable) {
    if (deviseTrackable) {
      var currentTime = moment();
      var lastSeen = moment(deviseTrackable);
      var lastSeenText = lastSeen.fromNow();
      var duration = currentTime.diff(lastSeen, "minutes");
    } else {
      var lastSeenText = "never";
      var duration = false;
    }

    if (duration && duration <= 20) {
      var color = "indigo-text";
    } else if (duration && duration > 20) var color = "grey-text";
    else {
      var color = "pink-text";
    }

    return (
      <span data-tip={"Last login " + lastSeenText}>
        <i
          className={"material-icons icon-in-row " + color}
          style={{ width: "20px" }}
        >
          account_box
        </i>
        <ReactTooltip />
      </span>
    );
  }

  renderLastSignIn(deviseTrackable) {
    if (deviseTrackable) {
      return <span>{moment(deviseTrackable).fromNow()}</span>;
    } else {
      return <span className="pink-text">Never</span>;
    }
  }

  renderImg(user, isCard = false) {
    let styleOptions = {};
    if (isCard) {
      styleOptions = {
        maxHeight: "96px",
        maxWidth: "96px",
        minHeight: "32px",
        minWidth: "32px",
        width: "100%",
      };
    } else {
      styleOptions = {
        height: "32px",
        maxWidth: "none",
        width: "32px",
      };
    }
    return (
      <img
        src={user.avatar_url}
        style={styleOptions}
        className="img-circle"
        alt={user.first_name}
      />
    );
  }

  renderBody() {
    var that = this;
    var users = [];

    _.forEach(this.state.users, function (user, index) {
      users.push(
        <tr key={index}>
          <td>
            {that.props.currentUser.admin ? (
              <a className="styled-link" href={"/users/" + user.id}>
                {that.renderImg(user)}
              </a>
            ) : (
              that.renderImg(user)
            )}
          </td>
          <td>
            {that.props.currentUser.admin ? (
              <a className="styled-link" href={"/users/" + user.id}>
                {user.last_name}
              </a>
            ) : (
              <span>{user.last_name}</span>
            )}
          </td>
          <td>
            {that.props.currentUser.admin ? (
              <a className="styled-link" href={"/users/" + user.id}>
                {user.first_name}
              </a>
            ) : (
              <span>{user.first_name}</span>
            )}
          </td>

          <EmailTd
            fieldValue={user.email}
            hideField={!that.props.currentUser.admin && user.hide_email}
          />

          <PhoneNumberTd
            fieldValue={user.formatted_phone_number}
            hideField={!that.props.currentUser.admin && user.hide_phone_number}
          />

          <td>{that.renderLocations(user.user_locations_html)}</td>
          <td>{that.renderPositions(user.user_positions_html)}</td>
          <td>
            {that.props.currentUser.admin && (
              <span>{that.renderLastSeenIcon(user.devise_trackable)}</span>
            )}
          </td>
          <td />
        </tr>
      );
    });

    return <tbody>{users}</tbody>;
  }

  resendInvites() {
    if (
      confirm(
        "Are you sure you want to re-send invites to employees that never logged in?"
      ) == true
    ) {
      var params = {
        sign_in_count: 0,
      };

      if (this.state.active == true || this.state.active == false) {
        params["active"] = this.state.active;
      }

      if (this.state.selectedLocationId) {
        params["location_id"] = this.state.selectedLocationId;
      }

      if (this.state.selectedPositionId) {
        params["position_id"] = this.state.selectedPositionId;
      }

      axios
        .get("/resend_invites", { params })
        .then(function (response) {
          toastr.success("Invites queued for re-sending");
        })
        .catch(function (error) {
          toastr.error("Unable to re-send invites");
          console.log(error);
        });
    }
  }

  exportExcel() {
    var params = {
      location_id: this.state.selectedLocationId,
      position_id: this.state.selectedPositionId,
    };

    if (this.state.active == true || this.state.active == false) {
      params["active"] = this.state.active;
    }

    if (this.state.archived) {
      params["archived"] = this.state.archived;
    }

    axios({
      method: "get",
      url: "/schedule_users_export",
      params: params,
      responseType: "json",
    })
      .then(function (response) {
        if (response.data) {
          toastr.info(
            "Your Excel Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads."
          );
        } else {
          toastr.error("Unable to export users at this time");
        }
      })
      .catch(function (error) {
        toastr.error("Unable to export users at this time");
      });
  }

  exportExcelPositions() {
    var params = {
      location_id: this.state.selectedLocationId,
      position_id: this.state.selectedPositionId,
    };

    if (this.state.active == true || this.state.active == false) {
      params["active"] = this.state.active;
    }

    if (this.state.archived) {
      params["archived"] = this.state.archived;
    }

    axios({
      method: "get",
      url: "/schedule_employee_positions_export",
      params: params,
      responseType: "json",
    })
      .then(function (response) {
        if (response.data) {
          toastr.info(
            "Your Excel Export will be generated shortly, an email with a link will be sent and the file will be available in your My Downloads."
          );
        } else {
          toastr.error("Unable to export employee positions at this time");
        }
      })
      .catch(function (error) {
        toastr.error("Unable to export employee positions at this time");
      });
  }

  userLimitReached = (userTally) => {
    if (userTally.limit == 0) return false;

    let userAllowedAfterOverLimit = 5;
    return userTally.active >= userTally.limit + userAllowedAfterOverLimit;
  };

  renderCards() {
    var that = this;
    var users = [];

    _.forEach(this.state.users, function (user, index) {
      users.push(
        <div className="well shadowDepth1" key={index}>
          <div className="row">
            <div className="col-xs-3 col-sm-2">
              {that.renderImg(user, true)}
            </div>
            <div className="col-xs-9 col-sm-10">
              {user.first_name + " " + user.last_name}

              {that.props.currentUser.admin && (
                <span className="pull-right">
                  <a href={"/users/" + user.id} className="styled-link">
                    <i className="material-icons pull-right">
                      keyboard_arrow_right
                    </i>
                  </a>
                </span>
              )}
              <br />

              {!that.props.currentUser.admin && user.hide_email ? (
                <div>-</div>
              ) : (
                <a
                  className="styled-link pointer-hand td-wrap-text"
                  href={"mailto:" + user.email}
                >
                  {user.email}
                </a>
              )}

              {!that.props.currentUser.admin && user.hide_phone_number ? (
                <span>-</span>
              ) : (
                <a
                  className="styled-link pointer-hand"
                  href={"tel:" + user.formatted_phone_number}
                >
                  {user.formatted_phone_number}
                </a>
              )}
            </div>
          </div>

          <br />
          <br />
          {that.renderLocations(user.user_locations_html)}
          <br />
          {that.renderPositions(user.user_positions_html)}
          <br />
          {that.props.currentUser.admin && (
            <span>
              <br />
              Last login: {that.renderLastSignIn(user.devise_trackable)}
            </span>
          )}
        </div>
      );
    });

    return <div>{users}</div>;
  }

  renderH1() {
    if (this.props.currentUser.admin) {
      if (this.state.active && !this.state.archived) {
        return <h1>Active Employees</h1>;
      } else if (this.state.active == false && !this.state.archived) {
        return <h1>Inactive Employees</h1>;
      } else if (this.state.archived) {
        return <h1>Archived Employees</h1>;
      } else {
        return <h1>All Employees</h1>;
      }
    } else {
      return <h1>Contact List</h1>;
    }
  }

  render() {
    var that = this;

    return (
      <div>
        {that.renderH1()}
        <div className="row">
          <LocationSelect
            locationId={this.props.locationId}
            locations={this.props.currentUserLocations}
            selectClassName="col-md-3 col-xs-12"
            newLocationCallback={(newLocation) => this.newLocation(newLocation)}
          />
          {that.props.currentUser.admin && (
            <div>
              <ActiveSelect
                newActiveCallback={(newActive) => this.newActive(newActive)}
                userTally={this.props.userTally}
              >
                {that.props.currentUser.superadmin ? (
                  <option value={1}>
                    Archived Employees ({this.props.userTally.archived})
                  </option>
                ) : null}
              </ActiveSelect>
              <UserRoleSelect
                newUserRoleCallback={(newUserRole) =>
                  this.newUserRole(newUserRole)
                }
              ></UserRoleSelect>
            </div>
          )}

          {that.props.currentUser.admin && (
            <div className="col-md-3 pull-right">
              <div className="pull-right col-md-12">
                <span className="dropdown">
                  <button
                    id="add"
                    type="button"
                    className="btn btn-pink btn-raised btn-md dropdown-toggle margin-right-five hidden-xs hidden-sm"
                    style={{ width: "48%" }}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    ADD
                    <span className="caret" />
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="add">
                    <li>
                      <a href={"/users/new"}>ADD EMPLOYEE</a>
                    </li>
                    <li>
                      <a href="/import_employees">IMPORT EMPLOYEES</a>
                    </li>
                  </ul>
                </span>
                <span className="dropdown">
                  <button
                    id="options"
                    type="button"
                    className="btn btn-indigo btn-raised btn-md dropdown-toggle hidden-xs hidden-sm"
                    style={{ width: "48%" }}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    OPTIONS
                    <span className="caret" />
                  </button>
                  <ul className="dropdown-menu" aria-labelledby="options">
                    <li>
                    <a
                      className="pointer-hand"
                      tabIndex="0"
                      role="button"
                      onClick={() => this.exportExcel()}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') this.exportExcel();
                      }}
                    >
                        EXPORT EMPLOYEES
                      </a>
                    </li>
                    <li>
                      <a
                        className="pointer-hand"
                        onClick={() => this.exportExcelPositions()}
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') this.exportExcelPositions();
                        }}
                      >
                        EXPORT POSITIONS
                      </a>
                    </li>
                    <li>
                      <a href="/employee_positions_importer">
                        IMPORT POSITIONS
                      </a>
                    </li>
                    <li>
                      <a href="/employee_statistics">SIZING INFORMATION</a>
                    </li>
                    <li>
                      <a
                        className="pointer-hand"
                        onClick={() => this.resendInvites()}
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') this.resendInvites();
                        }}
                      >
                        RESEND INVITES
                      </a>
                    </li>
                  </ul>
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="row">
          <PositionSelect
            positionId={this.props.positionId}
            positions={this.props.positions}
            selectClassName="col-md-3 col-xs-12"
            newPositionCallback={(newPosition) => this.newPosition(newPosition)}
          />
          <Search
            newSearchCallback={(newSearch) => this.newSearch(newSearch)}
          />
        </div>
        {that.props.currentUser.admin &&
          !this.userLimitReached(this.props.userTally) && (
            <a
              className="btn btn-pink btn-raised btn-long margin-right-five visible-xs visible-sm"
              href={
                "/users/new?location_id=" +
                this.state.selectedLocationId +
                "&position_id=" +
                this.state.selectedPositionId
              }
            >
              ADD
            </a>
          )}
        <br />
        {that.state.users.length && !that.state.loading ? (
          <div>
            <div className="hidden-xs hidden-sm">
              <table className="table table-clean table-white">
                <thead>
                  <tr>
                    <th></th>
                    <th>
                      <a
                        onClick={(e) => { e.preventDefault(); this.sortData("last_name"); }}
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by Last Name"
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.sortData("last_name");
                          }
                        }}
                      >
                        Last Name
                      </a>
                    </th>

                    <th>
                      <a
                        onClick={(e) => { e.preventDefault(); this.sortData("first_name"); }}
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by First Name"
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.sortData("first_name");
                          }
                        }}
                      >
                        First Name
                      </a>
                    </th>

                    <th className="th-width-18">
                      <a
                        onClick={(e) => { e.preventDefault(); this.sortData("email"); }}
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by Email"
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.sortData("email");
                          }
                        }}
                      >
                        Email
                      </a>
                    </th>

                    <th>
                      <a
                        onClick={(e) => { e.preventDefault(); this.sortData("phone_number"); }}
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by Phone Number"
                        tabIndex="0"
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            this.sortData("phone_number");
                          }
                        }}
                      >
                        Phone Number
                      </a>
                    </th>

                    <th>Locations</th>
                    <th>Positions</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                {this.renderBody()}
              </table>
            </div>
            <div className="visible-xs visible-sm">{this.renderCards()}</div>
            {this.renderPagination()}
          </div>
        ) : (
          <Loading
            loading={this.state.loading}
            noDataMessage={this.props.noRecordsMessage}
          />
        )}
      </div>
    );
  }
}

Users.propTypes = {
  currentUser: PropTypes.object,
  currentUserLocations: PropTypes.array,
  locations: PropTypes.array,
  positions: PropTypes.array,
  userTally: PropTypes.object,
  noRecordsMessage: PropTypes.string,
};

export default Users;
